function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-smiley-1,.cls-smiley-2,.cls-smiley-3{fill:none;}.cls-smiley-1,.cls-smiley-2{stroke:#000;}.cls-smiley-1{stroke-miterlimit:10;stroke-width:0.52px;}.cls-smiley-2{stroke-linecap:round;stroke-linejoin:round;stroke-width:0.52px;}"));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-smiley-1",
  fill: "currentColor",
  cx: 8.26,
  cy: 8.26,
  r: 8
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-smiley-2",
  fill: "currentColor",
  d: "M11.87,10A4.25,4.25,0,0,1,8,12.27,4.25,4.25,0,0,1,4.13,10",
  transform: "translate(0.26 0.26)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-smiley-2",
  fill: "currentColor",
  d: "M4.36,6.06a1,1,0,0,0,1.76.06",
  transform: "translate(0.26 0.26)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-smiley-2",
  fill: "currentColor",
  d: "M11.64,6.06a1,1,0,0,1-1.76.06",
  transform: "translate(0.26 0.26)"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-smiley-3",
  fill: "currentColor",
  x: 0.26,
  y: 0.26,
  width: 16,
  height: 16
});

function SvgSmileyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.52 16.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileyIcon);
export default __webpack_public_path__ + "static/media/smiley-icon.b58d00f9.svg";
export { ForwardRef as ReactComponent };